var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 257.108,
    height: 103.549,
    viewBox: "0 0 257.108 103.549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 257.108,
    height: 103.549,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.047,65.4c0,4.507-3.531,7.136-10.293,7.136H273.683V46.239H286c6.311,0,9.691,2.667,9.691,6.836a6.3,6.3,0,0,1-3.38,5.785,6.475,6.475,0,0,1,4.733,6.536M278.566,50.07v7.249h6.912c3.38,0,5.3-1.2,5.3-3.606,0-2.441-1.916-3.644-5.3-3.644Zm13.56,14.837c0-2.629-1.991-3.794-5.672-3.794h-7.888V68.7h7.888c3.681,0,5.672-1.165,5.672-3.794",
    transform: "translate(-155.132 -26.21)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.118,58.974V70.468h-4.7V59.575c0-3.569-1.765-5.3-4.77-5.3-3.343,0-5.6,2.028-5.6,6.047V70.468h-4.7V42.6h4.7V52.738a8.941,8.941,0,0,1,6.686-2.554c4.808,0,8.377,2.742,8.377,8.79",
    transform: "translate(-192.927 -24.145)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.413,68.639V80.4h-4.432V77.954c-1.127,1.728-3.306,2.7-6.311,2.7-4.582,0-7.475-2.517-7.475-6.01,0-3.343,2.254-5.972,8.339-5.972h5.184v-.3c0-2.742-1.653-4.357-5-4.357a9.934,9.934,0,0,0-6.086,1.991L398.8,62.591a14.106,14.106,0,0,1,8.49-2.479c5.784,0,9.127,2.742,9.127,8.527m-4.7,5.484V71.795h-4.845c-3.193,0-4.057,1.2-4.057,2.666,0,1.691,1.428,2.78,3.831,2.78a5.113,5.113,0,0,0,5.071-3.117",
    transform: "translate(-225.709 -34.073)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.462,60.112v4.47a5.981,5.981,0,0,0-1.089-.113c-3.569,0-5.822,2.1-5.822,6.2V80.4h-4.7V60.337h4.47v2.93c1.352-2.1,3.794-3.156,7.137-3.156",
    transform: "translate(-258.393 -34.073)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.237,68.639V80.4H503.8V77.954c-1.127,1.728-3.306,2.7-6.311,2.7-4.583,0-7.475-2.517-7.475-6.01,0-3.343,2.254-5.972,8.339-5.972h5.184v-.3c0-2.742-1.653-4.357-5-4.357a9.934,9.934,0,0,0-6.086,1.991l-1.84-3.419a14.105,14.105,0,0,1,8.49-2.479c5.784,0,9.127,2.742,9.127,8.527m-4.7,5.484V71.795H498.7c-3.193,0-4.057,1.2-4.057,2.666,0,1.691,1.428,2.78,3.831,2.78a5.113,5.113,0,0,0,5.071-3.117",
    transform: "translate(-277.758 -34.073)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.248,73.8a7.377,7.377,0,0,1-4.508,1.352c-4.395,0-6.912-2.329-6.912-6.761V58.74h-3.305V54.983h3.305V50.4h4.7v4.582H554.9V58.74h-5.371v9.541c0,1.953.976,3,2.779,3a4.219,4.219,0,0,0,2.629-.826Z",
    transform: "translate(-306.953 -28.569)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.346,137.121c0-7.85,6.01-13.522,14.086-13.522a13.32,13.32,0,0,1,10.405,4.395l-3.156,2.968a9.234,9.234,0,0,0-7.024-3.08,9.242,9.242,0,1,0,0,18.481,9.141,9.141,0,0,0,7.024-3.118l3.156,3.005a13.347,13.347,0,0,1-10.443,4.394c-8.038,0-14.048-5.672-14.048-13.523",
    transform: "translate(-152.674 -70.06)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.9,146.867v11.757h-4.432v-2.442c-1.127,1.728-3.305,2.7-6.311,2.7-4.582,0-7.475-2.517-7.475-6.01,0-3.343,2.253-5.972,8.339-5.972h5.184v-.3c0-2.742-1.653-4.357-5-4.357a9.934,9.934,0,0,0-6.086,1.991l-1.841-3.419a14.106,14.106,0,0,1,8.49-2.479c5.784,0,9.127,2.742,9.127,8.527m-4.7,5.484v-2.329h-4.845c-3.193,0-4.057,1.2-4.057,2.666,0,1.691,1.428,2.78,3.831,2.78a5.113,5.113,0,0,0,5.071-3.117",
    transform: "translate(-189.143 -78.415)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.953,138.34v4.47a5.98,5.98,0,0,0-1.089-.113c-3.568,0-5.822,2.1-5.822,6.2v9.729h-4.7V138.565h4.47v2.93c1.352-2.1,3.794-3.156,7.137-3.156",
    transform: "translate(-221.827 -78.415)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.362,138.667c0,6.236-4.32,10.292-10.179,10.292a8.271,8.271,0,0,1-6.649-2.855V148.7h-4.47V120.825h4.7v10.254a8.338,8.338,0,0,1,6.423-2.667c5.86,0,10.179,4.02,10.179,10.255m-4.77,0c0-3.831-2.554-6.273-5.935-6.273s-5.972,2.442-5.972,6.273,2.592,6.273,5.972,6.273,5.935-2.441,5.935-6.273",
    transform: "translate(-243.207 -68.487)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.7,147.13v11.494H563V147.731c0-3.569-1.766-5.3-4.771-5.3-3.343,0-5.6,2.028-5.6,6.047v10.142h-4.7V138.565h4.47v2.592a8.721,8.721,0,0,1,6.911-2.817c4.808,0,8.376,2.742,8.376,8.79",
    transform: "translate(-310.59 -78.415)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.749,138.738a12.464,12.464,0,0,0-2.535.264,4,4,0,0,1,1.688,3.242,3.385,3.385,0,0,1-.056.543,6.712,6.712,0,0,1,.9-.067c3.419,0,5.972,2.441,5.972,6.273s-2.554,6.273-5.972,6.273c-3.381,0-5.935-2.442-5.935-6.273a7.053,7.053,0,0,1,.639-3.022,4.027,4.027,0,0,1-3.235-3.367,10.164,10.164,0,0,0-2.136,6.389c0,6.01,4.508,10.292,10.668,10.292,6.235,0,10.705-4.282,10.705-10.292s-4.47-10.255-10.705-10.255",
    transform: "translate(-275.526 -78.641)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.411,142.838a2.634,2.634,0,1,1-2.535-2.7,2.716,2.716,0,0,1,2.535,2.7",
    transform: "translate(-280.096 -79.435)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.871,154.93v3.688a.654.654,0,0,0,.327.566l3.193,1.844a.653.653,0,0,0,.654,0l3.193-1.844a.654.654,0,0,0,.327-.566V154.93a.654.654,0,0,0-.327-.566l-3.193-1.844a.656.656,0,0,0-.654,0l-3.193,1.844a.654.654,0,0,0-.327.566",
    transform: "translate(-284.476 -86.403)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.7,209.956a5.708,5.708,0,0,1,.092-11.413,5.707,5.707,0,1,1-.092,11.413",
    transform: "translate(-74.328 -112.54)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.05,204.133a5.709,5.709,0,0,1-5.685,5.751,5.723,5.723,0,0,1-.055-11.445,5.691,5.691,0,0,1,5.739,5.694",
    transform: "translate(-46.302 -112.481)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.366,44.833A5.689,5.689,0,0,1,173.99,45a5.689,5.689,0,1,1,11.376-.172",
    transform: "translate(-98.622 -22.207)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.406,185.325a5.659,5.659,0,0,1-5.6-5.818,5.68,5.68,0,0,1,11.359.173,5.626,5.626,0,0,1-5.757,5.645",
    transform: "translate(-98.517 -98.597)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1,179.2a5.593,5.593,0,0,1,5.982-5.389,5.673,5.673,0,0,1-.551,11.333A5.592,5.592,0,0,1,39.1,179.2",
    transform: "translate(-22.162 -98.518)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.919,136.907a5.727,5.727,0,1,1-5.859-5.589,5.773,5.773,0,0,1,5.859,5.589",
    transform: "translate(-112.497 -74.435)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.686,20.262a5.682,5.682,0,1,1-5.63-5.776,5.654,5.654,0,0,1,5.63,5.776",
    transform: "translate(-74.437 -8.211)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.065,39.062A5.668,5.668,0,0,1,44.922,50.4a5.667,5.667,0,1,1,.144-11.333",
    transform: "translate(-22.258 -22.141)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.018,87.666a5.75,5.75,0,0,1-5.8,5.606,5.678,5.678,0,0,1-5.605-5.788,5.7,5.7,0,1,1,11.408.182",
    transform: "translate(-112.579 -46.395)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.731,14.426a5.683,5.683,0,0,1,5.611,5.81,5.71,5.71,0,0,1-11.417-.2,5.671,5.671,0,0,1,5.806-5.609",
    transform: "translate(-46.437 -8.176)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.163,131.066a5.664,5.664,0,0,1,5.653,5.773,5.708,5.708,0,1,1-11.411-.311,5.662,5.662,0,0,1,5.757-5.462",
    transform: "translate(-8.164 -74.292)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.107,93.029a5.639,5.639,0,0,1-5.618-5.782,5.7,5.7,0,1,1,5.618,5.782",
    transform: "translate(-8.213 -46.294)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.345,207.285a4.838,4.838,0,0,1-4.987,4.665,4.83,4.83,0,1,1,4.987-4.665",
    transform: "translate(-92.24 -114.665)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.423,52.425a4.819,4.819,0,1,1,4.793-4.881,4.774,4.774,0,0,1-4.793,4.881",
    transform: "translate(-40.035 -24.253)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.677,75.338a4.824,4.824,0,0,1-9.647-.009,4.824,4.824,0,0,1,9.647.009",
    transform: "translate(-98.645 -39.971)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.958,178.8a4.8,4.8,0,0,1-9.6.095,4.852,4.852,0,0,1,4.763-4.935,4.787,4.787,0,0,1,4.837,4.84",
    transform: "translate(-82.96 -98.605)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.381,173.985a4.827,4.827,0,1,1-4.77,4.9,4.788,4.788,0,0,1,4.77-4.9",
    transform: "translate(-40.024 -98.62)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.838,207.228a4.806,4.806,0,1,1-4.758-4.915,4.777,4.777,0,0,1,4.758,4.915",
    transform: "translate(-30.737 -114.677)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.618,70.6a4.757,4.757,0,0,1,4.846,4.81,4.823,4.823,0,0,1-9.646.049,4.757,4.757,0,0,1,4.8-4.86",
    transform: "translate(-24.27 -40.017)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.676,151.063a4.829,4.829,0,1,1-4.887-4.739,4.764,4.764,0,0,1,4.887,4.739",
    transform: "translate(-98.64 -82.94)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.785,113.221a4.768,4.768,0,0,1-4.825,4.84,4.807,4.807,0,0,1-.049-9.613,4.727,4.727,0,0,1,4.874,4.773",
    transform: "translate(-104.38 -61.471)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6,155.89a4.8,4.8,0,0,1,0-9.6,4.8,4.8,0,1,1,0,9.6",
    transform: "translate(-24.278 -82.922)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.542,113.27a4.808,4.808,0,1,1-4.806-4.864,4.806,4.806,0,0,1,4.806,4.864",
    transform: "translate(-122.961 -61.448)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.558,118.032a4.8,4.8,0,0,1-.149-9.6,4.8,4.8,0,1,1,.149,9.6",
    transform: "translate(-18.559 -61.462)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.4,167.394a4.814,4.814,0,0,1,9.628.077,4.888,4.888,0,0,1-4.862,4.839,4.814,4.814,0,0,1-4.765-4.916",
    transform: "translate(-114.729 -92.211)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.182,63.758a4.737,4.737,0,0,1-4.764-4.887,4.808,4.808,0,1,1,4.764,4.887",
    transform: "translate(-114.736 -30.676)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.347,47.659a4.8,4.8,0,1,1,4.865,4.781,4.789,4.789,0,0,1-4.865-4.781",
    transform: "translate(-82.954 -24.249)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.539,24.087a4.821,4.821,0,1,1,.073-9.642,4.821,4.821,0,0,1-.073,9.642",
    transform: "translate(-92.242 -8.187)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.249,216.908a4.8,4.8,0,1,1-4.787,4.866,4.722,4.722,0,0,1,4.787-4.866",
    transform: "translate(-61.48 -122.95)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1,167.454a4.77,4.77,0,0,1-4.819,4.842,4.847,4.847,0,0,1-4.813-4.881,4.784,4.784,0,0,1,4.754-4.721,4.711,4.711,0,0,1,4.878,4.759",
    transform: "translate(-8.202 -92.221)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.331,54.251a4.791,4.791,0,0,1,.079,9.582,4.792,4.792,0,1,1-.079-9.582",
    transform: "translate(-8.218 -30.751)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.065,189.023a4.812,4.812,0,1,1-9.619-.269,4.812,4.812,0,0,1,9.619.269",
    transform: "translate(-61.469 -104.346)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.836,19.259a4.812,4.812,0,0,1-9.623.052,4.812,4.812,0,1,1,9.623-.052",
    transform: "translate(-30.729 -8.16)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.854,118.043a4.81,4.81,0,1,1,.005-9.62,4.81,4.81,0,0,1-.005,9.62",
    transform: "translate(0 -61.458)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.241,42.3a4.8,4.8,0,1,1,4.842-4.817,4.75,4.75,0,0,1-4.842,4.817",
    transform: "translate(-61.485 -18.537)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.255,0a4.74,4.74,0,0,1,4.81,4.831,4.8,4.8,0,1,1-9.6-.182A4.751,4.751,0,0,1,113.255,0",
    transform: "translate(-61.479 0)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,118.51a3.357,3.357,0,0,1-3.375-3.355,3.418,3.418,0,0,1,3.317-3.247,3.3,3.3,0,0,1,.058,6.6",
    transform: "translate(-40.033 -63.433)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.891,115.282a3.423,3.423,0,0,1-3.34,3.225,3.3,3.3,0,1,1,3.34-3.225",
    transform: "translate(-86.903 -63.431)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.617,138.883a3.467,3.467,0,0,1,3.428-3.137,3.3,3.3,0,1,1-.322,6.587,3.4,3.4,0,0,1-3.106-3.45",
    transform: "translate(-40.026 -76.944)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.643,88.09a3.372,3.372,0,0,1,3.25,3.472,3.473,3.473,0,0,1-3.445,3.115,3.3,3.3,0,0,1,.195-6.587",
    transform: "translate(-86.905 -49.932)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.6,135.727a3.3,3.3,0,0,1,.077,6.6,3.3,3.3,0,1,1-.077-6.6",
    transform: "translate(-86.907 -76.934)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2,91.376a3.337,3.337,0,0,1-3.225,3.311,3.3,3.3,0,1,1-.023-6.6A3.324,3.324,0,0,1,77.2,91.376",
    transform: "translate(-40.032 -49.928)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.217,103.439A3.336,3.336,0,0,1,136,106.6a3.241,3.241,0,0,1-3.321-3.377,3.178,3.178,0,0,1,3.185-3.155,3.281,3.281,0,0,1,3.351,3.367",
    transform: "translate(-75.207 -56.724)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.878,154.239a3.265,3.265,0,0,1,.017-6.529,3.31,3.31,0,0,1,3.32,3.378,3.257,3.257,0,0,1-3.337,3.151",
    transform: "translate(-75.205 -83.727)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.575,100.084a3.232,3.232,0,0,1,3.314,3.217,3.186,3.186,0,0,1-3.194,3.315,3.267,3.267,0,1,1-.12-6.532",
    transform: "translate(-51.78 -56.731)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.236,111.91a3.3,3.3,0,1,1-3.279,3.27,3.4,3.4,0,0,1,3.279-3.27",
    transform: "translate(-63.461 -63.434)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.717,130.434a3.283,3.283,0,0,1-3.365-3.353,3.336,3.336,0,0,1,3.2-3.181,3.244,3.244,0,0,1,3.338,3.2,3.189,3.189,0,0,1-3.173,3.336",
    transform: "translate(-51.781 -70.23)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.218,127.224a3.3,3.3,0,0,1-3.179,3.2,3.24,3.24,0,0,1-3.359-3.339,3.188,3.188,0,0,1,3.147-3.2,3.31,3.31,0,0,1,3.39,3.337",
    transform: "translate(-75.207 -70.223)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.546,91.475a3.3,3.3,0,1,1-3.15-3.393,3.4,3.4,0,0,1,3.15,3.393",
    transform: "translate(-63.461 -49.926)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.256,166.153a3.3,3.3,0,1,1,3.288-3.258,3.39,3.39,0,0,1-3.288,3.258",
    transform: "translate(-63.459 -90.441)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.545,138.988a3.294,3.294,0,1,1-3.305-3.25,3.407,3.407,0,0,1,3.305,3.25",
    transform: "translate(-63.461 -76.94)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.546,67.639a3.295,3.295,0,1,1-3.171-3.374,3.4,3.4,0,0,1,3.171,3.374",
    transform: "translate(-63.461 -36.426)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.769,76.283a3.26,3.26,0,0,1-.189,6.516,3.311,3.311,0,0,1-3.234-3.46,3.255,3.255,0,0,1,3.422-3.056",
    transform: "translate(-51.776 -43.237)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.715,147.74a3.263,3.263,0,0,1,3.172,3.353,3.156,3.156,0,0,1-3.322,3.165,3.266,3.266,0,0,1-3.214-3.329,3.343,3.343,0,0,1,3.364-3.189",
    transform: "translate(-51.78 -83.743)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.862,82.78a3.264,3.264,0,0,1-3.18-3.345A3.155,3.155,0,0,1,136,76.261a3.264,3.264,0,0,1,3.222,3.321,3.339,3.339,0,0,1-3.357,3.2",
    transform: "translate(-75.207 -43.226)",
    fill: "#9fd983"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentLogo);
export default __webpack_public_path__ + "static/media/payment-logo.40190edbe3022538f38f1bbfcc18f1e6.svg";
export { ForwardRef as ReactComponent };